import { Office } from '@/app/features/organisation/types';
import { formatAddress } from '@app.raytd.com/store';
const OfficeTileContent = ({ office, numberOfOffices }: { office: Office, numberOfOffices?: number }) => {

    if (numberOfOffices === 0) {
        return (
            <div className="text-sm">
                No offices available.{" "}
                <a
                    href="/organisation"
                    className="underline hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
                    aria-label="Go to Organisation page to create a new office"
                >
                    Create a new office in your Organisation&#39;s profile.
                </a>
            </div>
        )
    }

    if (!office) {
        return <div className="text-sm">No office selected.</div>;
    }

    return (
        <div>
            <p className="font-medium">{office.name}</p>
            <p className="text-sm text-zinc-600">{formatAddress(office.address)}</p>
            <p className="text-sm text-zinc-600">{office.phone}</p>
            <p className="text-sm text-zinc-600">{office.email}</p>
        </div>
    )
}

export default OfficeTileContent;